<template>
    <el-form :ref="formName" class="cus-form" :model="formdata" :rules="rules" :label-position="labelPosition" :validate-on-rule-change="false" @submit.native.prevent :inline-message="true">
        <el-row>
            <el-col class="padding-left20" :span="column.colspan || defaultColspan" v-for="(column, index) in formColumns" :key="index + '_' + column.prop">
                <el-form-item :class="[(column.label && column.label.position) || labelPosition, 'item', column.prop]" :prop="column.prop">
                    <span
                        slot="label"
                        :title="column.label"
                        :class="{ 'item-label': true, 'line-height20': labelPosition != 'top' && charLength(column.label) > 8 && !(column.label && column.label.position == 'top') }"
                        :style="column.field_style"
                        v-if="column.label"
                        >{{ (column.label && column.label.content) || column.label }}</span
                    >
                    <ItemInput
                        ref="ItemInput"
                        v-model="formdata[column.prop]"
                        @input="valueChange(column)"
                        @change="blurChange(column)"
                        @imgclick="imgclick($event, column)"
                        @imgdelete="imgdelete($event, column)"
                        :readonly="filter_readonly(column)"
                        v-bind="column.config"
                        :type="column.type"
                        :pname="column.prop"
                        :spanMethod="column.spanMethod"
                        :placeholder="column.placeholder"
                        :options="filter_option(column)"
                        @extrabutton-click="ExtraButtonClick($event)"
                        :clearable="true"
                        :showCount="showCount(column)"
                        :collapseTags="column.collapseTags == false ? false : true"
                    ></ItemInput>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import ItemInput from './ItemInput'

export default {
    name: `CusForm`,
    components: { ItemInput },
    props: {
        uniqueName: String,
        data: Object,
        columns: Array,
        labelWidth: {
            type: String,
            default: `120px`
        },
        labelPosition: {
            type: String,
            validator: function(t) {
                return t === `top` || t === `left` || t === `right`
            },
            default: `left`
        }
    },
    data() {
        return {
            formName: ``,
            formdata: {},
            isExtraBtnClick: false
        }
    },
    created() {
        this.formName = this.uniqueName || `fn` + _.now()
        this.lastdata = {}
    },
    computed: {
        formColumns() {
            let that = this
            // that.formdata = {}
            // that.clearField()
            let newcs = this.columns.map(function(value, index, array) {
                if (that.data[value.prop] == undefined) {
                    that.data[value.prop] = value.default
                    if (`,checkbox`.indexOf(`,${value.type}`) > -1) {
                        that.data[value.prop] = !!that.data[value.prop]
                    }
                }
                if (that.lastdata[value.prop] != that.data[value.prop] || !_.has(that.formdata, value.prop)) {
                    // if(',multiselect,groupmultiselect,remotemultiselect,'.indexOf(`,${value.type},`)>-1){
                    //   that.lastdata[value.prop] =that.data[value.prop]||[]
                    // }else
                    if (`,rbool,bool`.indexOf(`,${value.type},`) > -1) {
                        that.lastdata[value.prop] = !!that.data[value.prop]
                        that.$set(that.formdata, value.prop, that.data[value.prop] == undefined ? value.default : !!that.data[value.prop]) // 解决 bool类型赋值
                    } else {
                        that.lastdata[value.prop] = that.data[value.prop]
                        that.$set(that.formdata, value.prop, that.data[value.prop] == undefined ? value.default : that.data[value.prop]) // 解决 bool类型赋值
                    }
                }
                return _.cloneDeep(value)
            })
            that.formdata.origion = { ...that.data }
            return newcs
        },
        defaultColspan() {
            return this.formColumns.length > 6 ? 12 : 24
        },
        rules() {
            let r = {}
            _.filter(this.columns, function(c) {
                return c.validate && c.validate.length > 0
            }).forEach(function(c) {
                r[c.prop] = c.validate
            })
            return r
        }
    },
    methods: {
        confirm() {
            let that = this
            return new Promise(resolve => {
                let fn = that.formName
                this.$refs[fn].validate(valid => {
                    if (valid) {
                        let d = Object.assign({}, that.formdata.origion, { ...that.formdata })
                        delete d.origion
                        d.isExtraBtnClick = that.isExtraBtnClick
                        resolve(that.$emit(`confirm`, d))
                    } else {
                        resolve(false)
                    }
                })
            })
        },
        validateField(prop) {
            let that = this
            let fn = that.formName
            this.$refs[fn].validateField(prop)
        },
        clearField() {
            this.formdata = this.lastdata
            this.lastdata = {}
            // this.$refs[this.formName].resetFields()
        },
        valueChange(column) {
            // 触发change事件
            // this.$forceUpdate()
            if (column.change) {
                column.change(this, { row: this.formdata, area: `form` })
            }
        },
        blurChange(column) {
            // 触发change事件
            if (column.blurchange) {
                column.blurchange(this, { row: this.formdata, area: `form` })
            }
        },
        imgclick($event, column) {
            this.$emit(`imgclick`, { ...$event, formdata: this.formdata, column: column })
        },
        imgdelete($event, column) {
            this.$emit(`imgdelete`, { event: $event, formdata: this.formdata, column: column })
        },
        filter_option(column) {
            let that = this
            if (column.options && _.isFunction(column.options)) {
                return column.options(this, { row: that.formdata, column, area: `form` })
            }
            return column.options
        },
        filter_readonly(column) {
            let that = this
            if (column.readonly && _.isFunction(column.readonly)) {
                return column.readonly(this, { row: that.formdata, column, area: `form` })
            }
            return column.readonly
        },
        ExtraButtonClick($event) {
            this.$emit(`extrabutton-click`, { ...$event, formdata: this.formdata })
        },
        charLength(str) {
            // 先把中文替换成两个字节的英文，在计算长度
            return ((str && str.content) || str || ``).replace(/[\u0391-\uFFE5]/g, `aa`).length
        },
        showCount(column) {
            if (!column || !column.showCount) {
                return 3
            }
            return column.showCount
        }
    }
}
</script>

<style scoped lang="less">
.cus-form {
    width: 100%;
    text-align: left;
    .item-label {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        // white-space: nowrap;
        text-align: justify;
        text-align-last: justify;
    }
}
</style>
<style lang="less">
.cus-form {
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-form-item.left {
        .el-form-item__label {
            width: 70px;
        }
        .el-form-item__content {
            margin-left: 70px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/CusForm.vue